<template>
  <router-link
    v-if="show"
    class="report-link btn-primary"
    :to="`/report/${primaryReportId}/folder/${hgFolderId}`">
  View Report
</router-link>
</template>

<script>
export default {
  props: {
    hgPrimaryReport: {
      type: Object,
      required: true,
    },
    hgFolderId: {
      type: String,
      required: true,
    },
    hgReportBlock: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    primaryReportId() {
      return this.hgPrimaryReport.id;
    },
    show() {
      return !this.hgReportBlock && this.hgPrimaryReport.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.report-link {
  padding: 10px 20px;
}

@media all and (max-width: 655px) {
  .report-link {
    margin-top: 40px;
  }
}
</style>
